module.exports = __webpack_public_path__ + "static/media/Note-Click-Bloom-Textures-Click_Boom_00041.05343b3a.png";